import { omit } from 'lodash';
import React, { useCallback, useMemo, useState } from 'react';
import { useWakeLock } from '../../../hooks';
export const LessonPageContext = React.createContext(undefined);
export function LessonPageContextProvider(props) {
    const { lesson, course, nextLesson, progress: initialProgress, userAuthorized } = props;
    const defaultIndex = useCallback(() => {
        const firstNotPassed = initialProgress.steps.findIndex(x => !x.passed);
        return firstNotPassed === -1 ? 0 : firstNotPassed;
    }, [initialProgress]);
    const [selectedIndex, selectIndex] = useState(defaultIndex);
    const [progress, setProgress] = useState(initialProgress);
    const exercise = useMemo(() => ({
        ...lesson.steps[selectedIndex],
        lesson: omit(lesson, 'exercises')
    }), [lesson, selectedIndex]);
    const saveRecording = useCallback(async (info) => {
        const step = lesson.steps[selectedIndex];
        return props.saveRecording != null
            ? props.saveRecording(info, lesson, step).then(setProgress)
            : console.dir(info);
    }, [lesson, props, selectedIndex]);
    const [focusMode, setFocusMode] = useState(false);
    useWakeLock(focusMode);
    const preferences = {
        exercise: {
            showSheet: true,
            showDrumKit: true,
        }
    };
    const context = {
        lesson, course, nextLesson, progress, userAuthorized,
        exercise, selectIndex, selectedIndex,
        focusMode, setFocusMode, preferences,
        saveRecording
    };
    return React.createElement(LessonPageContext.Provider, { value: context }, props.children);
}
export function useLessonPageContext() {
    const context = React.useContext(LessonPageContext);
    if (context === undefined) {
        throw new Error('useLessonPageContext must be used within a LessonPageContextProvider');
    }
    return context;
}
//# sourceMappingURL=LessonPageContext.js.map